module.exports = __webpack_public_path__ + "static/media/Daniel.3ce7cae9.png";